export const selectMonitoreosCasasState = (state) => state.monitoreosCasas;

export const selectMonitoreosCasasFormState = (state) => state.monitoreosCasas.form;
